import { render, staticRenderFns } from "./CvmatchLoading.vue?vue&type=template&id=db28ee0c&scoped=true&"
import script from "./CvmatchLoading.vue?vue&type=script&lang=js&"
export * from "./CvmatchLoading.vue?vue&type=script&lang=js&"
import style0 from "./CvmatchLoading.vue?vue&type=style&index=0&id=db28ee0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db28ee0c",
  null
  
)

export default component.exports